import { Tabs as BaseTabs } from '@base-ui/react';

import { TabsList } from './TabsList';
import { TabsTab } from './TabsTab';
import { TabsTabLink } from './TabsTabLink';

export const Tabs = {
  Root: BaseTabs.Root,
  List: TabsList,
  Tab: TabsTab,
  TabLink: TabsTabLink,
  Panel: BaseTabs.Panel,
};
